import ParameterWiseTable from "./ParameterWiseTable";
import MedalWiseTable from "./MedalWiseTable";
import ScoreWiseTable from "./ScoreWiseTable";
import TargetVsAchievementTable from "./TargetVsAchievementTable";
import AttendanceTable from "./AttendanceTable";
import EnrolmentTable from "./SummaryReport/EnrolmentTable";
import DropOutTable from "./SummaryReport/DropOutTable";
import PlacementTable from "./SummaryReport/PlacementTable";
import OperationsFinanceTable from "./SummaryReport/OperationsFinanceTable";
import RetentionTable from "./SummaryReport/RetentionTable";
import DemandDrivenPlacementTable from "./SummaryReport/DemandDrivenPlacementTable";
import OperationsHRTable from "./SummaryReport/OperationsHRTable";
import GovernanceAndEthicsTable from "./SummaryReport/GovernanceAndEthicsTable";
import SessionQualityTable from "./SummaryReport/SessionQualityTable";
import StakeholdersFeedbackTable from "./SummaryReport/StakeholdersFeedbackTable";
import CenterVisitBrandingTable from "./SummaryReport/CenterVisitBrandingTable";
import StaffTrainingTable from "./SummaryReport/StaffTrainingTable";
import AttendanceTableSummaryReport from "./SummaryReport/AttendanceTableSummaryReport";


const renderTable = (
  selectedTab: { id: number; name: string; code: string } | null,
  magicPageHeaderBtn: any[],
  magicTableHeaderBtn: any[],
  params: any,
  isInvalidSearch: boolean,
  onPaginationChange: (pageNo: number) => void,
  onSearch: (searchTerm: string) => void
) => {
  switch (selectedTab?.code) {
    case "PARAMETER_WISE":
      return (
        <ParameterWiseTable
        selectedTab={selectedTab}
        isInvalidSearch={isInvalidSearch}
        magicTableHeaderBtn={magicTableHeaderBtn}
        params={params}
        onPaginationChange={onPaginationChange}
        onSearch={onSearch}
        />
      );
    case "MEDAL_WISE":
      return (
        <MedalWiseTable
          selectedTab={selectedTab}
          isInvalidSearch={isInvalidSearch}
          magicPageHeaderBtn={magicPageHeaderBtn}
          magicTableHeaderBtn={magicTableHeaderBtn}
          params={params}
          onPaginationChange={onPaginationChange}
          onSearch={onSearch}
        />
      );
    case "SCORE_WISE":
      return (
        <ScoreWiseTable
          selectedTab={selectedTab}
          isInvalidSearch={isInvalidSearch}
          magicPageHeaderBtn={magicPageHeaderBtn}
          magicTableHeaderBtn={magicTableHeaderBtn}
          params={params}
          onPaginationChange={onPaginationChange}
          onSearch={onSearch}
        />
      );
    case "TARGET_VS_ACHIEVEMENT":
      return (
        <TargetVsAchievementTable
          selectedTab={selectedTab}
          isInvalidSearch={isInvalidSearch}
          magicPageHeaderBtn={magicPageHeaderBtn}
          magicTableHeaderBtn={magicTableHeaderBtn}
          params={params}
          onPaginationChange={onPaginationChange}
          onSearch={onSearch}
        />
      );
    case "ATTENDANCE":
      return (
        <AttendanceTable
          selectedTab={selectedTab}
          isInvalidSearch={isInvalidSearch}
          magicPageHeaderBtn={magicPageHeaderBtn}
          magicTableHeaderBtn={magicTableHeaderBtn}
          params={params}
          onPaginationChange={onPaginationChange}
          onSearch={onSearch}
        />
      );
      case "ENROLMENT":
        return (
          <EnrolmentTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
        case "ATTENDANCE_SUMMARY_REPORT":
      return (
        <AttendanceTableSummaryReport
          selectedTab={selectedTab}
          isInvalidSearch={isInvalidSearch}
          magicPageHeaderBtn={magicPageHeaderBtn}
          magicTableHeaderBtn={magicTableHeaderBtn}
          params={params}
          onPaginationChange={onPaginationChange}
          onSearch={onSearch}
        />
      );
      case "DROP_OUT":
        return (
          <DropOutTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "PLACEMENT":
        return (
          <PlacementTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "DEMAND_DRIVEN_PLACEMENT":
        return (
          <DemandDrivenPlacementTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "RETENTION":
        return (
          <RetentionTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "OPERATIONS_FINANCE":
        return (
          <OperationsFinanceTable 
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "OPERATIONS_HR":
        return (
          <OperationsHRTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "GOVERNANCE_AND_ETHICS":
        return (
          <GovernanceAndEthicsTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "SESSION_QUALITY":
        return (
          <SessionQualityTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "STAKEHOLDERS_FEEDBACK":
        return (
          <StakeholdersFeedbackTable 
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "CENTER_VISIT_BRANDING":
        return (
          <CenterVisitBrandingTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
      case "STAFF_TRAINING": 
        return (
          <StaffTrainingTable
            selectedTab={selectedTab}
            isInvalidSearch={isInvalidSearch}
            magicPageHeaderBtn={magicPageHeaderBtn}
            magicTableHeaderBtn={magicTableHeaderBtn}
            params={params}
            onPaginationChange={onPaginationChange}
            onSearch={onSearch}
          />
        );
    default:
      return <div>No Table Found</div>;
  }
};
const SelectedTable = ({
  selectedTab,
  magicPageHeaderBtn,
  magicTableHeaderBtn,
  params,
  isInvalidSearch,
  onPaginationChange,
  onSearch
}: {
  selectedTab: { id: number; name: string; code:string } | null;
  magicPageHeaderBtn: any[];
  magicTableHeaderBtn: any[];
  params: any;
  isInvalidSearch: boolean;
  onPaginationChange: (pageNo: number) => void;
  onSearch: (searchTerm: string) => void;
}) => {
  return (
    <div>
      {renderTable(selectedTab, magicPageHeaderBtn, magicTableHeaderBtn,params,isInvalidSearch,
  onPaginationChange,
  onSearch)}
    </div>
  );
};

export default SelectedTable;
